type Props = {
  intro: string;
  examples: readonly string[];
  onSelectExample: (text: string) => void;
  disabled?: boolean;
};

export function AssistantChatEmptyState({
  intro,
  examples,
  onSelectExample,
  disabled = false,
}: Props) {
  return (
    <div className="flex min-h-full flex-col px-1 py-1">
      <p className="text-sm text-[#576274] dark:text-gray-300">{intro}</p>
      <div className="min-h-4 flex-1" aria-hidden />
      <div>
        <p className="mb-2 text-xs font-medium uppercase tracking-wide text-[var(--lm-muted)] dark:text-slate-400">
          Examples
        </p>
        <div className="space-y-2">
          {examples.map((prompt) => (
            <button
              key={prompt}
              type="button"
              disabled={disabled}
              onClick={() => onSelectExample(prompt)}
              className="block w-full rounded-lg border border-[rgba(15,23,42,0.09)] bg-white px-3 py-2 text-left text-xs text-[#576274] shadow-[var(--shadow-card)] transition-colors hover:bg-[var(--lm-hover)] hover:text-[#101828] disabled:cursor-not-allowed disabled:opacity-50 dark:border-white/5 dark:bg-white/5 dark:text-gray-400 dark:shadow-none dark:hover:bg-white/10"
            >
              {prompt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
